import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FoehnInputComponent } from '@dsivd/prestations-ng';

import { YearPeriod } from '../../model/year-period';

@Component({
    selector: 'app-year-period',
    templateUrl: './year-period.component.html',
    providers: [
        {
            provide: FoehnInputComponent,
            useExisting: forwardRef(() => YearPeriodComponent),
            multi: true
        },
    ]
})
export class YearPeriodComponent extends FoehnInputComponent<YearPeriod> implements OnInit {

    @Input()
        startLabel: string;

    @Input()
        startRequired = true;

    @Input()
        endLabel: string;

    @Input()
        endRequired = false;

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.resetModel();
    }

    /**
     * Overriden method from FoehnInputComponent to keep coherence with validation error names
     * @param suffix suffix
     */
    buildChildName(suffix: string = ''): string {
        return `${this.name}.${suffix}`;
    }

    private resetModel(): void {
        this.model = new YearPeriod();
    }

}
